// extracted by mini-css-extract-plugin
export default {"mainWrapper":"notFound_mainWrapper__nd6hk"};